/**
 * Creates click events attached to search icons which when clicked will show or hide the search bar
 */
function searchBar() {
  var searchBar = document.querySelector('.js-search-bar');
  var searchBarIcons = document.querySelectorAll('.js-search-bar-icon');
  var searchBarCloseIcon = document.querySelector('.js-search-bar__close');

  if (searchBar && searchBarIcons.length && searchBarCloseIcon) {
    searchBarIcons.forEach((icon) => {
      icon.addEventListener('click', function(e) {
        e.preventDefault();
        searchBar.classList.toggle('is-active');
      });
    });
    searchBarCloseIcon.addEventListener('click', function(e) {
      e.preventDefault();
      searchBar.classList.toggle('is-active');
    });
  }
}

function productAccordion() {
  $('.description-accordion').click(function() {
    $(this).toggleClass('active');
    if ($(this).next().css('display') === 'block') {
      $(this).next().fadeOut("fast");
      $(this).children().removeClass('accordion-arrow-up');
    } else {
      $(this).next().fadeIn("fast");
      $(this).children().addClass('accordion-arrow-up');
    }
  });
}

/**
 * Initialise functions
 */
document.addEventListener('DOMContentLoaded', function() {
  searchBar();
  productAccordion();
});